/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-16 08:40:10
 *
 *******************************************************/
//flow

import type { Action } from './store.type';

export const SEND_SUPPORT_TICKET_REQUEST = 'SEND_SUPPORT_TICKET_REQUEST';
type SEND_SUPPORT_TICKET_REQUEST_TYPE = 'SEND_SUPPORT_TICKET_REQUEST';

export const SEND_SUPPORT_TICKET_SUCCESS = 'SEND_SUPPORT_TICKET_SUCCESS';
type SEND_SUPPORT_TICKET_SUCCESS_TYPE = 'SEND_SUPPORT_TICKET_SUCCESS';

export const SEND_SUPPORT_TICKET_FAILURE = 'SEND_SUPPORT_TICKET_FAILURE';
type SEND_SUPPORT_TICKET_FAILURE_TYPE = 'SEND_SUPPORT_TICKET_FAILURE';

export const RESET_SEND_SUPPORT_TICKET = 'RESET_SEND_SUPPORT_TICKET';
type RESET_SEND_SUPPORT_TICKET_TYPE = 'RESET_SEND_SUPPORT_TICKET';

type SendSupportTicketSuccess = {
  data: {
    status: string,
    code: number
  }
};

type SendSupportTicketFailure = {
  error: any
};

type SendSupportTicketRequestAction = Action<SEND_SUPPORT_TICKET_REQUEST_TYPE, null>;

type SendSupportTicketSuccessAction = Action<
  SEND_SUPPORT_TICKET_SUCCESS_TYPE,
  SendSupportTicketSuccess
>;

type SendSupportTicketFailureAction = Action<
  SEND_SUPPORT_TICKET_FAILURE_TYPE,
  SendSupportTicketFailure
>;

type ResetSendSupportTicketAction = Action<RESET_SEND_SUPPORT_TICKET_TYPE, null>;

export type SendSupportTicketAction =
  | SendSupportTicketRequestAction
  | SendSupportTicketSuccessAction
  | SendSupportTicketFailureAction
  | ResetSendSupportTicketAction;

export type SendSupportTicketState = {
  SendSupportTicketLoading: boolean,
  SendSupportTicketSuccess: boolean,
  error: any
};
